import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Contextmenu from "vue-contextmenujs"

Vue.prototype.$SERVER_HOST = window.base_config.host_url;
Vue.prototype.$SHOW_SMS = window.base_config.show_SMS;
 
Vue.use(Contextmenu);
Vue.use(ElementUI);
 
let vm = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

export default vm;
